import { animation, colors, fontSizes } from '../../styles';

export const secondarylinkstyles = `
  color: ${colors.linkDefault};
  text-decoration: none;
  font-weight: 700;
  
  &:hover {
    text-decoration: underline;
    color: ${colors.linkHover};
  }

  u {
    text-decoration: none;
  }
`;

export const primarylinkstyles = `
  display: flex;
  align-items: center;
  color: ${colors.linkDefault};
  font-family: Lato Black, sans-serif;
  font-size: ${fontSizes.paragraph.medium.fontSize};
  letter-spacing: 0.16px;
  line-height: normal;
  font-weight: 900;
  text-transform: uppercase;
  text-decoration: none;
  transition: ${animation.general.transition};

  &:hover {
    color: ${colors.linkHover};
  }
`;
